// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__1Po2a","appear":"Modal_appear__2S9Xa","close":"Modal_close__3uLS1"};